import { Toaster } from 'react-hot-toast';
import WalletScanner from './components/WalletScanner';
import './App.css'

function App() {
  return (
    <div className="min-h-screen w-full fixed inset-0" style={{ backgroundColor: '#353570' }}>
      <div className="container mx-auto px-4 py-8 h-full overflow-y-auto">
        <div className="flex justify-center mb-8">
          <img 
            src="/koii-logo.svg" 
            alt="Koii Logo" 
            className="h-16 w-auto"
          />
        </div>
        <Toaster position="top-right" />
        <WalletScanner />
      </div>
    </div>
  );
}

export default App;